import React, { useCallback } from 'react';

import AutoCompleteDropdown from 'components/uiLibrary/FormInputs/BaseComponents/AutoCompleteDropdown';

import { TP } from 'constants/index';

import { useQuery } from 'utils/react-query';

import queries from 'containers/Organizations/queries';

import { useTranslation } from 'src/i18n';

const transformEmployee = employee => {
  if (!employee) {
    return null;
  }

  const { profile, ...rest } = employee;
  let name = '';

  if (profile?.user?.name) {
    name = profile?.user?.name;
  }

  if (profile?.user?.email) {
    name += ` (${profile?.user?.email})`;
  }

  return {
    ...rest,
    profile,
    name,
  };
};

export const useAppliedOrgEmployee = (filter, options) => {
  const { enabled = true } = options || {};
  const shouldFetchFilterValue =
    !!filter?.organization?.id && (!filter?.name || !filter?.id) && (!!filter?.id || !!filter?.profile?.user?.id);

  return useQuery(
    queries.getOrganizationEmployees({
      id: filter?.organization?.id,
      filters: {
        ...(filter?.id && { id: filter.id }),
        ...(!filter?.id && filter?.profile?.user?.id && { user_id: filter.profile.user.id }),
      },
      limit: 1,
      queryConfig: {
        enabled: enabled && shouldFetchFilterValue,
        select: response => {
          const value = response?.data?.[0];

          return transformEmployee(value);
        },
        ...(!shouldFetchFilterValue && filter?.name && filter?.id && { initialData: { data: [filter] } }),
      },
    }),
  );
};

const OrgEmployeeDropdown = ({
  className,
  orgId,
  value,
  onChange,
  isDisabled = false,
  onBlur,
  disablePortal = false,
  label = `${TP}.FN_ORGANISATION_EMPLOYEE`,
  placeholder = `${TP}.FN_ORGANISATION_EMPLOYEE`,
}) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const query = useCallback(
    props =>
      queries.getOrganizationEmployees({
        ...props,
        id: orgId,
        queryConfig: {
          ...props.queryConfig,
          select: response =>
            response?.data?.reduce((acc, employee) => {
              if (employee?.profile?.user?.id) {
                acc.push(transformEmployee(employee));
              }

              return acc;
            }, []),
          enabled: !!orgId && props.queryConfig?.enabled !== false,
        },
      }),
    [orgId],
  );

  const { data: employee } = useAppliedOrgEmployee(value);

  return (
    <AutoCompleteDropdown
      className={className}
      label={t(label)}
      placeholder={t(placeholder)}
      value={employee}
      onChange={onChange}
      onBlur={onBlur}
      searchQuery={query}
      isDisabled={isDisabled || !orgId}
      disablePortal={disablePortal}
    />
  );
};

export default OrgEmployeeDropdown;
